import { ONBOARDING_DEFAULT_FORM_VALUES } from "./onboardingDefaultFormValues"

export const ONBOARDING_DEFAULT_STATE = {
    formValues: ONBOARDING_DEFAULT_FORM_VALUES,
    submittedSteps: [],
    stepHistory: [],
}
